var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41546 3.3367C4.27129 5.47921 3.09375 8.32419 3.09375 11.3623C3.09375 17.6143 8.19055 22.6896 14.4473 22.6896C17.4703 22.6896 20.3174 21.5129 22.4616 19.3704C24.6058 17.2279 25.7833 14.3829 25.7833 11.3448C25.7833 5.09286 20.6865 0 14.4297 0C11.4068 0 8.55964 1.17663 6.39789 3.31914L6.41546 3.3367ZM22.778 11.3448C22.778 13.5751 21.9168 15.6649 20.335 17.2455C18.7532 18.826 16.6618 19.6865 14.4473 19.6865C9.84262 19.6865 6.09911 15.9459 6.09911 11.3448C6.09911 9.11446 6.9603 7.02463 8.54206 5.44409C10.1238 3.86355 12.2153 3.00303 14.4473 3.00303C19.052 3.00303 22.7955 6.74365 22.7955 11.3448H22.778Z",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 23.0946C21.7345 22.6271 20.9516 22.5937 20.3899 23.0111C20.3218 23.0612 13.8713 27.82 7.86321 23.0111C7.31858 22.577 6.51864 22.577 5.99102 23.0445C5.75274 23.2449 0.13616 28.154 0 37.7551C0 38.1391 0.15318 38.5065 0.425499 38.7736C0.697818 39.0408 1.07226 39.1911 1.46372 39.1911H26.3979C27.1809 39.1911 27.8276 38.5733 27.8446 37.8052C27.8446 37.4211 28.0999 28.3209 22.2621 23.0779V23.0946ZM2.97849 36.3525C3.42101 30.9091 5.83784 27.4861 7.11434 26.0167C12.3565 29.4397 17.9901 27.82 21.0877 25.9833C24.0492 29.2727 24.73 34.0148 24.9002 36.3525H2.97849Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.e3ed9187bc7d8a2b59b493e0dbb9dd14.svg";
export { ForwardRef as ReactComponent };